<div
  class="bg-white flex justify-between py-3 px-5 cursor-pointer max-w-screen-sm min-h-20"
  [class.opacity-40]="!isAvailable(product)"
  (click)="goToProduct(product)"
>
  <div class="pr-5">
    <p
      *ngIf="product[ProductKeys.ShopName]"
      class="font-accent text-xs font-semibold pt-1.5 leading-4.5 text-neutral-500"
    >
      <i class="icon icon-chef-hat"></i>
      {{ product[ProductKeys.ShopName] }}
    </p>
    <p class="font-accent text-base font-bold pt-1.5 leading-4.5">
      {{ product[ProductKeys.Name] }}
    </p>
    <p
      *ngIf="product[ProductKeys.Description]"
      class="font-base text-sm pt-1.5 line-clamp-2"
    >
      {{ product[ProductKeys.Description] }}
    </p>
    <ul class="flex flex-wrap py-3">
      <li
        class="py-1 pl-0 pr-3"
        *ngIf="!isAvailable(product)"
      >
        <app-tag-atom
          color="neutral"
          text="Produit indisponible"
        ></app-tag-atom>
      </li>
      <li
        class="py-1 pl-0 pr-3"
        *ngFor="let label of visibleLabels(product[ProductKeys.Labels])"
      >
        <app-tag-atom
          [color]="label.color ? label.color : 'neutral'"
          [text]="label.name"
          [lineThrough]="label.line_through"
        ></app-tag-atom>
      </li>
    </ul>
    <ng-container *ngIf="product[ProductKeys.Discount]; else priceOnly">
      <app-price-atom
        class="pl-0 p-1.5"
        [amount]="product[ProductKeys.Discount]"
      ></app-price-atom>
      <app-tag-atom
        class="p-1.5"
        color="success"
        text="{{ product[ProductKeys.Price] | discountPercent: product[ProductKeys.Discount] }}"
      ></app-tag-atom>
      <app-price-atom
        class="p-1.5"
        [amount]="product[ProductKeys.Price]"
        [discount]="true"
      ></app-price-atom>
    </ng-container>
    <ng-template #priceOnly>
      <app-price-atom
        class="pl-0 p-1.5"
        [amount]="product[ProductKeys.Price]"
      ></app-price-atom>
    </ng-template>
  </div>
  <div class="relative height-fit-content">
    <img
      *ngIf="product.images?.thumbnail?.url"
      class="rounded w-28 push-image object-cover"
      [src]="product.images?.thumbnail?.url"
      alt="image"
    />
    <app-add-button-atom
      *ngIf="isAvailable(product)"
      class="absolute right-1.5 bottom-1.5"
    ></app-add-button-atom>
  </div>
</div>
